/**
 * @file paddle 客户案例
 * @author wanzhongyun
 */
import React, {useMemo, useState} from 'react';
import {Button} from 'antd';
import classNames from 'classnames';
import {IVerticalTabText} from '../../types';
import A from '../../../../components/a/A';

const VerticalTabText: React.FC<IVerticalTabText> = React.memo(props => {
    const [selectedKey, setSelectedKey] = useState<string>('');
    if (!selectedKey && props.tabs.length > 0) {
        setSelectedKey(props.tabs[0].title);
    }

    const selectedTabContent = useMemo(() => {
        return props.tabs.find(tab => tab.title === selectedKey)?.content;
    }, [selectedKey, props.tabs]);

    const menuItemHasImg = useMemo(() => {
        return props.tabs.some(t => !!t.titleIconUrl);
    }, [props.tabs]);

    return (
        <div className="paddle-cc-vtt">
            <div className="paddle-cc-vtt-body clear-both">
                <div className="paddle-cc-vtt-menu-background">

                </div>
                <div
                    className={classNames(
                        'paddle-cc-vtt-menu',
                        menuItemHasImg && 'paddle-cc-vtt-menu-hasimg'
                    )}
                >
                    {props.tabs.map(tab => (
                        <div
                            key={tab.title}
                            className={classNames(
                                'paddle-cc-vtt-menu-item',
                                selectedKey === tab.title && 'paddle-cc-vtt-menu-item-selected'
                            )}
                            onClick={() => setSelectedKey(tab.title)}
                            onMouseEnter={() => setSelectedKey(tab.title)}
                        >
                            {!!tab.titleIconUrl
                            && (
                                <div className="paddle-cc-vtt-menu-item-background-wrap">
                                    <div
                                        className="paddle-cc-vtt-menu-item-background"
                                        style={{backgroundImage: `url(${tab.titleIconUrl})`}}
                                    />
                                    {!!tab.titleIconSelectedUrl
                                    && (
                                        <div
                                            className="paddle-cc-vtt-menu-item-background-selected"
                                            style={{backgroundImage: `url(${tab.titleIconSelectedUrl})`}}
                                        />
                                    )}
                                </div>
                            )}
                            {!tab.titleIconUrl && tab.title}
                        </div>
                    ))}
                </div>
                <div className="paddle-cc-vtt-menu-img-wrap">
                    {!!selectedTabContent?.imageUrl
                    && (
                        <img src={selectedTabContent?.imageUrl} alt={selectedTabContent?.title} />
                    )}
                </div>
                <div className="paddle-cc-vtt-content">
                    <div className="paddle-cc-vtt-content-title">
                        {selectedTabContent?.title}
                    </div>
                    <div className="paddle-cc-vtt-content-text"
                         {...{dangerouslySetInnerHTML:{__html: selectedTabContent?.text ?? ''}}}
                    />
                    <div
                        className="paddle-cc-vtt-content-about"
                        {...{dangerouslySetInnerHTML: {__html: selectedTabContent?.about ?? ''}}}
                    />
                    <div className="paddle-cc-vtt-content-btns">
                        <A
                            href={selectedTabContent?.btnLink}
                            target
                        >
                            <Button
                                className="paddle-cc-vtt-content-btn"
                                type="primary"
                                size="large"
                            >
                                {selectedTabContent?.btnText}
                            </Button>
                        </A>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default VerticalTabText;
